import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import useCurrency from 'hooks/useCurreny';
import MaskInput from 'components/MaskedInput';
import { formatSwissNumber } from 'utils/formatNumber';

interface Props {
  getCost: string | number;
  getGains: string | number;
  getROI: string | number;
}

const CropFieldTotal: FC<Props> = ({ getCost, getGains, getROI }) => {
  const { t } = useTranslation();
  const { currencyGreen } = useCurrency();

  return (
    <div>
      <div className="font-bold text-lg mb-8">
        {t('fieldTotalCropRotation')}
      </div>
      <div className="flex mx-[-0.5rem] mb-8">
        <div className='w-1/3 px-2'>
          <MaskInput
            titleClassName="bg-disable-gradient top-[-9px] left-[8px]"
            title={t('cost') + ` (${currencyGreen})`}
            className="w-full"
            disabled
            value={formatSwissNumber(Math.round(Number(getCost)))}
          />
        </div>
        <div className='w-1/3 px-2'>
          <MaskInput
            titleClassName="bg-disable-gradient top-[-9px] left-[8px]"
            title={t('gains') + ` (${currencyGreen})`}
            className="w-full"
            disabled
            value={formatSwissNumber(Math.round(Number(getGains)))}
          />
        </div>
        <div className='w-1/3 px-2'>
          <MaskInput
            titleClassName="bg-disable-gradient top-[-9px] left-[8px]"
            title={t('roi') + ` (${currencyGreen})`}
            className="w-full"
            disabled
            value={formatSwissNumber(Math.round(Number(getROI)))}
          />
        </div>
      </div>
    </div>
  );
};

export default CropFieldTotal;
